import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private alertService: AlertService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean> {
    return this.authService.isUserAuthenticated$.pipe(
      map((data) => {
        return true;
      }),
      catchError((error) => {
        if (error.status == 401) {
          this.authService.login();
          throw new Error("Unauthorized");
        }
        this.alertService.onAlert({
          title: 'Authenticatie problemen',
          message: 'Geef deze melding door als het probleem regelmatig voorkomt. ' + error.message,
          type: 'error'
        })
        return of(false);
      })
    );
  }
}
